import React, { useCallback, useState } from 'react';
import * as Styled from './ImagePreview.styled';
import { vhFilePropTypes } from '../../../proptypes/Actions';
import PreviewModal from '../PreviewModal/PreviewModal';
import OpenMediaModalButton from '../../atoms/OpenMediaModalButton/OpenMediaModalButton';
import WrapMediaPreview from '../../atoms/WrapMediaPreview/WrapMediaPreview';

const ImagePreview = (props) => {
  const [visible, setVisible] = useState(false);

  const handleOpen = useCallback(() => {
    setVisible(true);
  }, []);
  const handleClose = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <>
      <WrapMediaPreview>
        <OpenMediaModalButton onClick={handleOpen} />
        <Styled.PreviewImg src={props.file.url} />
      </WrapMediaPreview>
      <PreviewModal mediaPreview={true} onHide={handleClose} show={visible}>
        <Styled.OpenedImgWrapper>
          <Styled.OpenedImg src={props.file.url} />
        </Styled.OpenedImgWrapper>
      </PreviewModal>
    </>
  );
};

ImagePreview.propTypes = {
  file: vhFilePropTypes,
};

export default ImagePreview;
